<template>
  <div class="mapactive-wrap">
    <close-btn
      v-if="modal"
      class="btn-tertiary"
      @close="close"
    />
    <div class="text-center">
      <div class="searchactive-toggle">
        <div v-show="!showReload">
          <!-- Add class .active to .btn-map-search to toggle state -->
          <label
            class="btn btn-map-search"
            :class="{ active: searchactive }"
            for="activesearch"
          >
            <input
              id="activesearch"
              v-model="searchactive"
              type="checkbox"
              name="activesearch"
              autocomplete="off"
              value="true"
            >
            <i class="icon"><icon-check /></i>
            {{ $t("common:autoUpdateSearch") }}
          </label>
        </div>
        <div v-show="showReload">
          <button
            class="btn btn-map-search"
            type="button"
            data-ident="mapSearchActivatorRedo"
            @click="doSearch"
          >
            <i class="icon"><icon-redo /></i>
            {{ $t("common:refreshSearch") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* ICONS */
import IconRedo from 'ICON:IconRedo';
import IconCheck from 'ICON:IconCheck';
import CloseBtn from 'components/CloseButton.vue';

export default {
  components: {
    IconRedo,
    IconCheck,
    CloseBtn,
  },
  props: {
    showReload: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchactive: true,
    };
  },
  watch: {
    searchactive() {
      // tell searchmap component
      this.$emit('searchactive', this.searchactive);
    },
  },
  methods: {
    doSearch() {
      // tell searchmap component
      this.$emit('start-search');
    },
    close() {
      this.$emit('close-map');
    },
  },
};
</script>
<style lang="scss" scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.mapactive-wrap {
  width: 100%;
  position: absolute;
  top: 13px;
  z-index: 500;
  font-size: 1rem;
}

.searchactive-toggle {
  padding: 0.3em 0.6em;
}

.btn-map-search {
  display: inline-block;
  padding: 0 1em 0 0;
  margin: 0;
  height: 2em;
  border: none;

  @include font_size_s;

  line-height: 1.9em;
  background: var(--color_ci);
  color: #fff;

  input {
    display: none;
  }

  .icon {
    @include radius(50%);

    margin: 0 0.5em 0 -1px;
    float: left;
    height: 2em;
    width: 2em;
    padding: 0;
    text-align: center;
    line-height: 2em;
    background: $color_grey_100;
    color: #fff;
  }

  #app:not(.isTouchDevice) &:hover,
  &.active {
    .icon {
      background: var(--color_ci);
      background: #fff;
      color: var(--color_ci);
    }
  }
}
</style>
